import React, { useState } from "react";
import Topbar from "../../../components/Topbar";
import Leftbar from "../../../components/Leftsidebar";
import { Link } from "react-router-dom";
import "../contract.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Contractdetails = ({handleStep}) => {

  const contentArr = [
    { label: "Course content" },
    { label: "Creator Led-contract" },
    { label: "Original Content" },
    { label: "Sponsored content" },
  ];

  const countryArr = [
    { label: "India" },
    { label: "Usa" },
    { label: "Japan" },
    { label: "France" },
  ];

  const countryState = [
    { label: "Delhi" },
    { label: "Calefornia" },
    { label: "Tokio" },
    { label: "France" },
  ];

  const serviceArr = [
    { label: "reels" },
    { label: "Content creator" },
  ];

  const [currentPassword, setCurrentPassword] = useState("");
  const [firstName, setFirstname] = useState("");
  const [lastName, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [adharnum, setAdharnum] = useState("");
  const [pennum, setPennum] = useState("");
  const [address, setAddress] = useState("");

  const [showSidebar, setShowSidebar] = useState(false);
  const [content, setContent] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [service, setService] = useState("");
  const [startDate, setStartDate] = useState(new Date());


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };
  return (
    <>
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          {/* <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} /> */}
          <main className="main-content border-radius-lg">
            {/* <Topbar handleSidebar={handleSidebar} /> */}
            <div>
              {/* <div className="header header-bg pb-6">
                <div className="container-fluid">
                  <div className="header-body">
                    <div className="row align-items-center py-4">
                      <div className="col-lg-6 col-7">
                        <nav
                          aria-label="breadcrumb"
                          className="d-none d-md-inline-block ml-md-4"
                        >
                          <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">
                                <i className="fas fa-home" />
                              </Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/update-password"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Update Password</span></Link>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="container-fluid Contrcat-conatiner">
                <div className="row">
                  <div className="col">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h5 className="mb-0">Create Contract</h5>
                      </div>
                      <div className="card-body">
                        <span className="mb-0 create-contract-title">Contract Details</span>
                        <div className="row mt-2">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="contract-label">Project Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Current Password"
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                value={currentPassword}
                              />
                            </div>

                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="contract-label">
                                Contract Type *
                              </label>
                              <div>
                                <select
                                  className="form-select contrcat-input "
                                  aria-label="Default select example"
                                  value={content}
                                  onChange={(e) => setContent(e.target.value)}
                                >
                                  <option value="">Select Contract</option>
                                  {contentArr.map((item, index) => (
                                    <option key={index} value={item.label}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </div>
                          </div>
                        </div>

                        <span className="mb-0 create-contract-title">Creator Details</span>
                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">First Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="First Name"
                                onChange={(e) => setFirstname(e.target.value)}
                                value={firstName}
                              />
                            </div>

                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">Last Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                onChange={(e) => setLastname(e.target.value)}
                                value={lastName}
                              />
                            </div>

                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">Age *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder=" Age"
                                onChange={(e) => setAge(e.target.value)}
                                value={age}
                              />
                            </div>

                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">Aadhar Number *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Aadhar number"
                                onChange={(e) => setAdharnum(e.target.value)}
                                value={adharnum}
                              />
                            </div>

                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">PAN Number *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Pan number"
                                onChange={(e) => setPennum(e.target.value)}
                                value={pennum}
                              />
                            </div>

                          </div>

                        </div>
                        <div className="row mt-2">
                          <div className="col-12">
                            <div className="form-group">
                              <label className="contract-label">Address *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Address"
                                onChange={(e) => setAddress(e.target.value)}
                                value={address}
                              />
                            </div>

                          </div>


                        </div>

                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">
                                Country *
                              </label>
                              <div>
                                <select
                                  className="form-select contrcat-input "
                                  aria-label="Default select example"
                                  value={country}
                                  onChange={(e) => setCountry(e.target.value)}
                                >
                                  <option value="">Select Contract</option>
                                  {countryArr.map((item, index) => (
                                    <option key={index} value={item.label}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">
                                State *
                              </label>
                              <div>
                                <select
                                  className="form-select contrcat-input "
                                  aria-label="Default select example"
                                  value={state}
                                  onChange={(e) => setState(e.target.value)}
                                >
                                  <option value="">Select Contract</option>
                                  {countryState.map((item, index) => (
                                    <option key={index} value={item.label}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">City *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Current Password"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                              />
                            </div>

                          </div>

                        </div>

                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">Zip Code *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="zip code"
                                onChange={(e) => setZipcode(e.target.value)}
                                value={zipcode}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">
                                Services *
                              </label>
                              <div>
                                <select
                                  className="form-select contrcat-input "
                                  aria-label="Default select example"
                                  value={service}
                                  onChange={(e) => setService(e.target.value)}
                                >
                                  <option value="">Select service</option>
                                  {serviceArr.map((item, index) => (
                                    <option key={index} value={item.label}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </div>
                          </div>


                        </div>

                        <span className="mb-0 create-contract-title">More Details</span>
                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">Contract Start Date *</label>
                              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="custom-datepicker" />
                            </div>

                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="contract-label">
                                Contract End Date *
                              </label>
                              <div>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="custom-datepicker" />

                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">

                            <div className="form-group">
                              <label className="contract-label">Budget *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Budget"
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                value={currentPassword}
                              />

                            </div>
                          </div>

                        </div>

                        <button onClick={handleStep}
                          className="btn submit-btn-contract mt-4"
                        >
                          <span>Submit</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Contractdetails;
